import { getNewsDetail } from '$lib/services/http/cds/apis/news';
import type { PageLoad } from './$types';
import { error } from '@sveltejs/kit';

export const load = (async ({ params }) => {
  const post = await getNewsDetail(params.postId);
  if (post) {
    return {
      post
    };
  }
  throw error(404, {
    message: `No post found with id - ${params.postId}.`
  });
}) satisfies PageLoad;
